import { Debounce } from 'angular-debounce-throttle';
import { ThemingService } from 'src/app/theming.service';
import { AppComponent } from 'src/app/app.component';
import { Component, OnInit} from '@angular/core';
import { ExportClientsService } from 'src/app/export-clients.service';
import { AuthService } from 'src/app/auth.service';
import { LambdaService } from 'src/app/lambda.service';

declare let $: any;

import * as XLSX from "xlsx";

@Component({
  selector: 'app-clients',
  templateUrl: './clients.component.html',
  styleUrls: ['./clients.component.scss']
})
export class ClientsComponent implements OnInit {

  private readonly allowedImportLoginMethods = ['PASSWORD', 'OTP_ONLY'];

  constructor(
    public appComponent: AppComponent,
    public themingService: ThemingService,
    private exportClientsService: ExportClientsService,
    private authService: AuthService,
    public lambdaService: LambdaService
  ) {}

  /**
   * variables para subir correos para reenvio
   */

  file: File | null = null;
  emails: string[] = [];
  invalidEmails: string[] = [];
  hasErrors = false;
  fileName = '';
  // Estado de procesamiento
  resendEmailFinished = false;
  isProcessing = false;
  processedCount = 0;
  totalCount = 0;
  progressPercent = 0;



  modalLoading = false;
  isUploading = false;
  uploadFinished = false;

  previewPageSize: number = 10;

  showErrorsModal = false;
  rowErrors: { index: string; error: string }[] = [];

  // Datos completos del Excel
  previewData: any[] = [];
  previewError = false;

  // Para paginar
  previewDataPagination: any[] = [];
  previewPages: number[] = [];
  previewTotalPages = 0;
  previewPageNumber = 1;

  // Valida que el Excel tenga columnas correctas
  xlsxValid = true;


  uploadingStyle = '';
  uploadPercentaje = 0;

  clients: any[] = [];
  totalAmount: number = 0;
  searchString: string = '';
  order: string = 'DESC';

  pages: number[] = [1];
  totalPages: number = 1;
  currentPage: number = 1;
  maxNumberOfPages: number = 5; //Odd numbers only
  amount: number = 20;

  loading: boolean = false;
  clientIdToDelete!: number;
  clientUsernameToDelete!: string;
  modalDelete = false;
  permissions: any = {};
  usersAndBeneficiaries: any[] = [];

  currentAdminUser: any;

  async ngOnInit(): Promise<void> {
    this.currentPage = 1;
    this.currentAdminUser = await this.authService.getCurrentUserDetails();
    this.getClients();
    this.getUsersAndBeneficiaries();
    //this.themingService.getThemingService();
    await this.authService.getUserPermissions().then((permissions) => {
      this.permissions = permissions || {};
    });
  }

  @Debounce(500)
  serchClients() {
    this.currentPage = 1;
    this.getClients();
  }

  @Debounce(500)
  filterSearch() {
    this.currentPage = 1;
    this.getClients();
  }

  async getClients() {
    this.loading = true;
    await this.lambdaService
      .getClients(
        this.themingService.shopId,
        this.searchString,
        this.currentPage - 1,
        this.amount,
        this.order
      )
      .then((data: any) => {
        this.clients = data.data;
        this.totalPages = data.pagination[0].lastPage;
        this.formatPages()
      }).catch((error: Error)=>{
        console.log(error)
      })
    this.loading = false;
  }

  deleteClient(response: number) {
    if (response) {
      this.loading = true;
      this.lambdaService.deleteClient(this.themingService.shopId, this.clientIdToDelete, this.clientUsernameToDelete, this.currentAdminUser)
        .then((data) => {
          this.getClients();
          $('#deleteClientModal').modal('show');
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    }
    this.modalDelete = false;
  }


  notVerified(){
    $('#errorClientsModal').modal('show');
  }
  closeModal(){
    $('#errorClientsModal').modal('hide');
    $('#deleteClientModal').modal('hide');
  }

  movePage(forward: boolean) {
    this.loading = true;
    this.currentPage = this.currentPage + (forward ? 1 : -1);
    this.getClients();
  }

  goToPage(page: number) {
    this.loading = true;
    this.currentPage = page;
    this.getClients();
  }

  async formatPages() {
    this.appComponent.goToTop();
    this.pages = [];
    let pagesLength = this.maxNumberOfPages;
    let startPage = 1;
    if (this.maxNumberOfPages >= this.totalPages) {
      pagesLength = this.totalPages;
    } else {
      startPage = this.currentPage - (this.maxNumberOfPages - 1) / 2;
      if (startPage < 1) {
        startPage = 1;
      }

      if (
        this.currentPage + (this.maxNumberOfPages - 1) / 2 >=
        this.totalPages
      ) {
        startPage = this.totalPages - this.maxNumberOfPages + 1;
      } else {
        pagesLength = pagesLength - 1;
      }

      if (startPage >= (this.maxNumberOfPages - 1) / 2) {
        startPage = startPage + 1;
        pagesLength = pagesLength - 1;
      }
    }
    this.pages = Array.from({ length: pagesLength }, (_, i) => i + startPage);
  }

  async getUsersAndBeneficiaries() {
    this.loading = true;
    try {
      const shopId = this.themingService.shopId;
      const response: any = await this.lambdaService.getUsersAndBeneficiaries(shopId);
      if(shopId != 12){
        response.data.forEach((item: any) => {
          delete item.employeeId;
        });
      }
      this.usersAndBeneficiaries = response.data.filter((c: any) => c.clientPlans.length);
    } catch (error) {
      console.error('Error al obtener los clientes:', error);
    }
    this.loading = false;
  }

  downloadClientsFile(format: 'excel' | 'json' | 'csv' | 'txt') {
    if (!this.permissions?.exportClients) {
      return;
    }
    this.exportClientsService.exportToFile(this.usersAndBeneficiaries, 'Clientes', format);
  }

  async openEmailsUploadModal() {
    $('#customerSendEmail').modal('show');
  }

  async openClientUploadModal() {
    $('#customerUploadModal').modal('show');

    this.modalLoading = true;
    this.isUploading = false;

    this.previewData = [];
    this.previewDataPagination = [];
    this.previewPages = [];
    this.previewTotalPages = 0;
    this.previewError = false;

    const form = document.querySelector('#uploadClientsForm') as HTMLFormElement;
    form.reset();

    this.modalLoading = false;
  }

  private isValidEmail(email: string): boolean {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(String(email).trim());
  }

  private normalizeImportLoginMethod(value: unknown): number | null {
    if (value === null || value === undefined || String(value).trim() === '') {
      return 1;
    }

    const normalizedValue = String(value).trim().toUpperCase();
    if (normalizedValue === '1' || normalizedValue === 'PASSWORD') {
      return 1;
    }

    if (normalizedValue === '0' || normalizedValue === 'OTP_ONLY') {
      return 0;
    }

    return null;
  }

  private processTitularBeneficiaries(data: any[]): any[] {
    const clients: any[] = [];
    let currentClient: any = null;

    for (const row of data) {
      const relationship = (row.relationship || '').toLowerCase().trim();

      // Verificar si es titular
      const isTitular = ['titular', 'tit'].includes(relationship);

      if (isTitular) {
        // Crear nuevo cliente titular
        const newClient = {
          ...row,
          beneficiaries: []
        };
        clients.push(newClient);
        currentClient = newClient;
      } else if (currentClient) {
        // Agregar como beneficiario al cliente actual
        currentClient.beneficiaries.push(row);
      } else {
        // Error: beneficiario sin titular anterior
        console.warn('Beneficiario sin titular encontrado:', row);
      }
    }

    return clients;
  }

  getError(index: number): string {
    const realIndex = (this.previewPageNumber - 1) * this.previewPageSize + index;
    const row = this.previewData[realIndex];

    if (!row) return "";

    if (!row.firstName) return "El nombre es obligatorio";
    if (!row.lastName) return "El apellido es obligatorio";

    console.log("relationship",row.relationship)
    // Validar relación
    if (!row.relationship) return "La relación es obligatoria";
    const rel = (row.relationship || '').toLowerCase().trim();
    const validRelationships = [
      'titular', 'tit', 'hijo', 'hija', 'suegro', 'suegra', 'perro', 'gato', 'padre', 'madre', 'conyugue', 'conyuge'
    ];
    if (!validRelationships.includes(rel)) return "Relación inválida";

    // Email requerido + formato válido
    if (!row.email) return "El email es obligatorio";
    if (!this.isValidEmail(row.email)) return "Formato de email inválido";

    // Validar duplicados dentro del Excel (cédula)
    const nationalIdRepeat = this.previewData.filter(
      x => String(x.nationalId).trim() === String(row.nationalId).trim()
    );
    if (nationalIdRepeat.length > 1) {
      return `Cédula duplicada en el archivo: ${row.nationalId}`;
    }

    // Validar duplicados dentro del Excel (correo)
    const emailRepeat = this.previewData.filter(
      x => String(x.email).trim().toLowerCase() === String(row.email).trim().toLowerCase()
    );
    if (emailRepeat.length > 1) {
      return `Email duplicado en el archivo: ${row.email}`;
    }

    // Validación opcional gender
    if (row.gender && !["male", "female"].includes(String(row.gender).toLowerCase())) {
      return "Gender debe ser male o female";
    }

    return "";
  }


  loadPreviewClients() {
    const pageSize = this.previewPageSize;
    const start = (this.previewPageNumber - 1) * pageSize;
    this.previewDataPagination = this.previewData.slice(start, start + pageSize);
  }

  handleListOfPages() {
    const pageSize = 10;
    this.previewTotalPages = Math.ceil(this.previewData.length / pageSize);
    this.previewPages = Array.from({ length: this.previewTotalPages }, (_, i) => i + 1);
  }

  movePreviewPage(next: boolean) {
    if (next && this.previewPageNumber < this.previewTotalPages) {
      this.previewPageNumber++;
    } else if (!next && this.previewPageNumber > 1) {
      this.previewPageNumber--;
    }
    this.loadPreviewClients();
  }

  goToPreviewPage(page: number) {
    this.previewPageNumber = page;
    this.loadPreviewClients();
  }

  onFileSelected(event: any) {
    this.previewPageNumber = 1;
    this.previewError = false;

    const file: File = event.target.files[0];
    if (!file) return;

    const fileReader = new FileReader();

    fileReader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const ws = workbook.Sheets[workbook.SheetNames[0]];
      const [rawHead]: any = XLSX.utils.sheet_to_json(ws, { header: 1 });

      // Normalizador
      const normalize = (arr: any[]) =>
        (arr || [])
          //.filter(c => c !== null && c !== undefined && String(c).trim() !== "")
          .map(c =>
            String(c)
              .trim()
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/\s+/g, " ")
          );

      const head = normalize(rawHead);

      // CABECERAS DEFINIDAS
      const validHead = normalize([
        "firstName",
        "lastname",
        "nationalId",
        "employeeId",
        "relationship",
        "phoneNumber",
        "email",
        "gender",
        "birthDate",
        "registrationDate",
        "loginMethod"
      ]);

      const isValidHeader =
        head.length === validHead.length &&
        head.every((v, i) => v === validHead[i]);

      this.xlsxValid = isValidHeader;

      if (!this.xlsxValid) {
        this.previewError = true;
        return;
      }

      let jsonData: any[] = XLSX.utils.sheet_to_json(ws);

      console.log("jsonData",jsonData)
      // Quitar filas duplicadas completas
      jsonData = jsonData.filter(
        (obj, index, self) =>
          index === self.findIndex(o => JSON.stringify(o) === JSON.stringify(obj))
      );

      console.log("jsonData",jsonData)

      //validate date
      function hasValidDateValue(value: any) {
        return value !== null && value !== undefined && value !== '';
      }

      // Normalizar fechas y limpiar datos
      this.previewData = jsonData.map(row => ({
        ...row,
        birthDate: this.normalizeBirthDate(row.birthDate),
        registrationDate: hasValidDateValue(row.registrationDate)
          ? this.normalizeBirthDate(row.registrationDate)
          : new Date().toISOString().split('T')[0], // Esto da YYYY-MM-DD
        loginMethod: this.normalizeImportLoginMethod(row.loginMethod)
      }));

      // ← AQUÍ APLICAMOS EL NUEVO PROCESAMIENTO
      this.previewData = this.processTitularBeneficiaries(this.previewData);

      // Validar errores por fila
      for (let i = 0; i < this.previewData.length; i++) {
        const client = this.previewData[i];
        // Validar titular
        const err = this.getErrorFromClient(client, i);
        if (err) {
          this.previewError = true;
        }
        // Validar beneficiarios
        if (client.beneficiaries) {
          for (let j = 0; j < client.beneficiaries.length; j++) {
            const beneficiary = client.beneficiaries[j];
            const beneficiaryErr = this.getErrorFromBeneficiary(beneficiary, i, j);
            if (beneficiaryErr) {
              this.previewError = true;
            }
          }
        }
      }

      if (this.previewError) {
        this.generateErrorList(); // ← Mostrar lista de errores
      }

      this.loadPreviewClients();
      this.handleListOfPages();
    };

    fileReader.readAsArrayBuffer(file);
  }

  // Validar titular
  getErrorFromClient(client: any, clientIndex: number): string {
    if (!client.firstName) return `El nombre del titular en el cliente ${clientIndex + 1} es obligatorio`;
    if (!client.lastName) return `El apellido del titular en el cliente ${clientIndex + 1} es obligatorio`;
    if (!client.email) return `El email del titular en el cliente ${clientIndex + 1} es obligatorio`;
    if (!this.isValidEmail(client.email)) return `Formato de email inválido para el titular en el cliente ${clientIndex + 1}`;
    if (client.loginMethod !== 0 && client.loginMethod !== 1) {
      return `El loginMethod del titular en el cliente ${clientIndex + 1} es inválido. Solo se permite 1/PASSWORD o 0/OTP_ONLY`;
    }
    return "";
  }

  // Validar beneficiario
  getErrorFromBeneficiary(beneficiary: any, clientIndex: number, beneficiaryIndex: number): string {
    if (!beneficiary.firstName) return `El nombre del beneficiario ${beneficiaryIndex + 1} del cliente ${clientIndex + 1} es obligatorio`;
    if (!beneficiary.lastName) return `El apellido del beneficiario ${beneficiaryIndex + 1} del cliente ${clientIndex + 1} es obligatorio`;

    // Solo validar formato si el email existe
    if (beneficiary.email && !this.isValidEmail(beneficiary.email)) {
      return `Formato de email inválido para el beneficiario ${beneficiaryIndex + 1} del cliente ${clientIndex + 1}`;
    }

    return "";
  }

  generateErrorList() {
    this.rowErrors = [];

    this.previewData.forEach((client, clientIndex) => {
      const clientErr = this.getErrorFromClient(client, clientIndex);
      if (clientErr) {
        this.rowErrors.push({
          index: `${clientIndex + 1}`,
          error: clientErr
        });
      }

      if (client.beneficiaries) {
        client.beneficiaries.forEach((beneficiary: any, beneficiaryIndex: number) => {
          const beneficiaryErr = this.getErrorFromBeneficiary(beneficiary, clientIndex, beneficiaryIndex);
          if (beneficiaryErr) {
            this.rowErrors.push({
              index: `Cliente ${clientIndex + 1}, Beneficiario ${beneficiaryIndex + 1}`,
              error: beneficiaryErr
            });
          }
        });
      }
    });

    $('#errorListModal').modal('show');
    this.showErrorsModal = true;
  }

  /**
   * funciones para procesar correos de reenvio
   */

  onEmailsFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.file = input.files[0];
      this.fileName = this.file.name;
      this.readFile();
    }
  }

  readFile(): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      // 👉 Usa sheet_to_json SIN { header: 1 } → obtienes objetos con encabezados como claves
      const jsonData: any[] = XLSX.utils.sheet_to_json(sheet);

      if (jsonData.length === 0) {
        this.setError('El archivo está vacío');
        return;
      }

      // Verificar que al menos una clave se parezca a "email" (case-insensitive)
      const firstRow = jsonData[0];
      const emailKey = Object.keys(firstRow).find(
        key => typeof key === 'string' && key.trim().toLowerCase() === 'email'
      );

      if (!emailKey) {
        this.setError('La columna "email" no fue encontrada');
        return;
      }

      // 👉 Extraer solo los valores de la columna "email"
      const rawEmails: string[] = jsonData
        .map(row => row[emailKey])
        .filter(value => {
          // Filtrar: no null, no undefined, no string vacío, no "undefined"
          if (value == null) return false;
          const str = String(value).trim();
          return str !== '' && str.toLowerCase() !== 'undefined';
        })
        .map(value => String(value).trim());

      console.log("rawEmails", rawEmails);

      if (rawEmails.length === 0) {
        this.setError('No se encontraron correos válidos en la columna "email"');
        return;
      }

      this.validateEmails(rawEmails);
    };
    reader.readAsArrayBuffer(this.file!);
  }

  private validateEmails(rawEmails: string[]): void {
    const validEmails: string[] = [];
    this.invalidEmails = [];

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (const email of rawEmails) {
      if (!email) continue; // ignorar vacíos
      if (emailRegex.test(email)) {
        validEmails.push(email);
      } else {
        this.invalidEmails.push(email);
      }
    }

    this.emails = [...new Set(validEmails)]; // eliminar duplicados

    if (this.invalidEmails.length > 0) {
      this.hasErrors = true;
    } else {
      this.hasErrors = this.emails.length === 0;
    }
  }

  private setError(msg: string): void {
    this.hasErrors = true;
    this.invalidEmails = [msg];
    this.emails = [];
  }

  async onSendAll(): Promise<void> {
    if (this.hasErrors || this.emails.length === 0) return;

    this.isProcessing = true;
    this.processedCount = 0;
    this.totalCount = this.emails.length;
    this.progressPercent = 0;

    const batchSize = 10;
    const delayMs = 1500;

    for (let i = 0; i < this.emails.length; i += batchSize) {
      const batch = this.emails.slice(i, i + batchSize);

      // Ejecutar en paralelo dentro del lote (hasta 10 simultáneos)
      await Promise.all(batch.map(email => this.resendVerificationEmail(email)));

      this.processedCount += batch.length;
      this.progressPercent = Math.round((this.processedCount / this.totalCount) * 100);

      // No esperar después del último lote
      if (i + batchSize < this.emails.length) {
        await this.sleep(delayMs);
      }
    }

    this.resendEmailFinished = true;
    this.isProcessing = false;
  }

  private sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async resendVerificationEmail(username: string) {
    this.loading = true;
    const url = 'https://cognito-idp.us-east-1.amazonaws.com/';
    
    const headers = {
      'Accept-Encoding': 'gzip, deflate, br',
      'Authorization': 'AWS4-HMAC-SHA256 Credential=<Credential>, SignedHeaders=<Headers>, Signature=<Signature>',
      'Content-Type': 'application/x-amz-json-1.1',
      'User-Agent': '<UserAgentString>',
      'X-Amz-Date': '20230613T200059Z',
      'X-Amz-Target': 'AWSCognitoIdentityProviderService.ResendConfirmationCode',
    };

    let userPoolWebClientId = JSON.parse(this.themingService.shopTheming[0].amplifyConfig).userPoolWebClientId;
    console.log("userPoolWebClientId",userPoolWebClientId)
    const body = {
      ClientId: userPoolWebClientId,
      Username: username,
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        this.loading = false;
        const errorBody = await response.text();
        throw new Error(`Error ${response.status}: ${errorBody}`);
      }
      const data = await response.json();
      console.log("success: ",data)
    } catch (error) {
      console.error('❌ Error', error);
    }
  }

  closeErrorModal(){
    $('#errorListModal').modal('hide');
  }

  private normalizeBirthDate(value: any): string | null {
    if (value == null || value === '') return null;

    // Caso 1: Ya en formato ISO
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }
    
    // Caso 3: DD/MM/YYYY
    const str = String(value).trim();
    const parts = str.split('/');
    if (parts.length === 3) {
      const [d, m, y] = parts;
      if (d && m && y) {
        const day = d.padStart(2, '0');
        const month = m.padStart(2, '0');
        let year = y;
        if (y.length === 2) {
          const yy = parseInt(y, 10);
          year = (yy > 50 ? '19' : '20') + y.padStart(2, '0');
        }
        const yNum = parseInt(year, 10);
        if (yNum < 1900 || yNum > 2100) return null;
        return `${year}-${month}-${day}`;
      }
    }

    // Caso 2: Número de Excel (serial)
    const num = typeof value === 'number' ? value : parseFloat(value);
    if (!isNaN(num) && num >= 1 && num <= 100000) {
      console.log("SOY SERIAL EXCEL")
      // Conversión segura: usar 1970 como pivote
      const daysSince1970 = num - 25569; // 25569 es serial de 1970-01-01 en Excel
      const ms = daysSince1970 * 86400 * 1000;
      const date = new Date(ms);

      // Corrección de zona horaria: ajustar al día local que representa la fecha
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');

      if (year < 1900 || year > 2100) return null;
      return `${year}-${month}-${day}`;
    }


    return null;
  }

  async confirmUploadClients() {
    if (this.previewError || !this.previewData.length) return;

    this.isUploading = true;           // ⬅ ACTIVAMOS ESTADO
    this.uploadPercentaje = 0;

    // this.previewData ya está agrupado como clientes con beneficiarios
    const chunkSize = 10;
    const chunks: any[] = [];

    for (let i = 0; i < this.previewData.length; i += chunkSize) {
      chunks.push(this.previewData.slice(i, i + chunkSize));
    }

    // SIMULACIÓN DE ENVÍO (sustituye con tu API real)
    for (let i = 0; i < chunks.length; i++) {
      const chunk = chunks[i];

      console.log("chunk", chunk);

      // Enviar clientes con beneficiarios
      await this.lambdaService.importClients(this.themingService.shopTheming[0].shopId, chunk);

      // opcional: barra de progreso
      this.uploadPercentaje = Math.round(((i + 1) / chunks.length) * 100);
    }

    this.isUploading = false; 
    this.uploadFinished = true;       // ⬅ DESACTIVAMOS ESTADO
    const form = document.querySelector('#uploadClientsForm') as HTMLFormElement;
    form.reset();
    // Vaciar tabla y previsualización
    this.previewData = [];
    this.previewError = false;
  }

  async downloadTemplate() {
    const XLSX_ = XLSX;
    // Crear libro Excel
    const wb = XLSX_.utils.book_new();
    // Encabezados del archivo
    const headers = [
      'firstName',
      'lastName',
      'nationalId',
      'employeeId',
      "relationship",
      'phoneNumber',
      'email',
      'gender',
      'birthDate',
      'registrationDate',
      'loginMethod'
    ];
    // Crear una fila de ejemplo (opcional)
    const sampleRow = {
      firstName: '',
      lastName: '',
      nationalId: '',
      employeeId: '',
      relationship: '',
      phoneNumber: '',
      email: '',
      gender: '',
      birthDate: '',
      registrationDate: '',
      loginMethod: 1
    };
    // Convertir la fila en hoja
    const ws = XLSX_.utils.json_to_sheet([sampleRow], { header: headers });
    // Agregar la hoja al libro
    XLSX_.utils.book_append_sheet(wb, ws, 'Clientes');
    // Descargar archivo
    XLSX_.writeFile(wb, 'Plantilla_Importar_Clientes.xlsx');
  }

}
